import { License } from './license.models';

export class SetLicenses {
  static readonly type = '[LicenseState] SetLicenses';
  constructor(public readonly licenses: License[]) {}
}
